import styled from "styled-components";

// Colors
import { white } from "../../../style/colors";

const SortIcon = styled.i`
  display: inline-block;
  margin-left: 6px;
  color: ${({ selected }) => (selected ? white : 'rgba(255, 255, 255, 0.7)')};
  font-size: 18px;
  vertical-align: middle;
  pointer-events: none;
  transition: all 0.2s;
`;

export default SortIcon;
